//记得在 src\components\lang\zhLoad.js 里面添加对象
const manualWeighDelivery = {
};
export default manualWeighDelivery



// WEBPACK FOOTER //
// ./src/page/bd/manualWeighDelivery/lang/manualWeighDelivery.zh.js